import styled from 'styled-components';
import AntdModal from '../../AntdModal';
import {typographyStyles} from '../../../utils/styles';

const StyledModalWithIcon = styled(AntdModal)`
  .ant-modal-content {
    .ant-modal-body {
      padding-top: 40px;

      .ant-space-item {
        display: flex;
      }
    }
  }
`;

const StyledModalWithIconDescription = styled.p`
  ${typographyStyles.body.regular};

  color: ${props => props.theme.colors.neutral_7};
  text-align: center;

  svg {
    height: 24px;
    width: 24px;

    path {
      fill: ${props => props.theme.colors.primary_6};
    }
  }
`;

const StyledModalWithIconTitle = styled.p`
  ${typographyStyles.heading.h5};

  color: ${props => props.theme.colors.neutral_10};
  text-align: center;

`;

export {
  StyledModalWithIcon,
  StyledModalWithIconDescription,
  StyledModalWithIconTitle,
};
